import type {
  PasskeyCallbackReason,
  PasskeyCallbackStatus,
} from '@modules/passkey/interfaces/passkey-callback.interface';

export const resolvePasskeyCallbackStatus = (reason: PasskeyCallbackReason): PasskeyCallbackStatus => {
  if (reason === 'userRejected') {
    return 'cancelled';
  }

  if (reason === 'challengeExpired') {
    return 'expired';
  }

  return 'error';
};
